import axios from 'axios';
import { guilds } from '@/config/profile-config.js'
// import { useApp } from '@/composables/state/profileState';

if (!import.meta.env.VITE_APP_ABMI_API_BASE_URL) {
  throw new Error('ABMI API Env not set: VUE_APP_ABMI_API_BASE_URL, VUE_APP_ABMI_API_KEY');
}
const abmiApiUrl = import.meta.env.VITE_APP_ABMI_API_BASE_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
  // params: { tsn, year }
});

export async function loadSpeciesInfo (params) {
  const apiFct = '/species/get-species-detail-by-name';

  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}
export async function loadHabitatInfo (params) {
  const apiFct = '/habitat/get-habitat-detail';

  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}
export async function getPreNextRecordInfo (state, isHabitat) {
  let apiFct, params;
  if (!isHabitat) {
    apiFct = '/species/get-previous-next-species';
    params = { tsn: state.tsn, year: state.year, id: state.tsn };
  } else {
    apiFct = '/habitat/get-previous-next-habitat';
    params = { year: state.year, id: state.tsn };
  }

  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

export async function getGuilds (state) {
  const apiFct = '/species/get-species-guilds';

  if (!state?.isSpecies) {
    return null;
  }

  const guildCalls = [];
  const currentGuild = Object.values(guilds[state?.groupName] ?? guilds.other);
  currentGuild.forEach(guild => {
    guildCalls.push(abmiAxios.get(apiFct, { params: { tsn: state.tsn, guilds: guild.list.map(x => x.name ?? x) } })); /* x can be a string or a object (use name field) */
  });
  try {
    const data = await Promise.all(guildCalls); // result matches the input ajax call order.
    // sort guild to match input/config guild orders
    const dataFormat = data.map((x, index) => {
      const guildNames = currentGuild[index].list.map(x => x.name ?? x);
      return { data: x.data.guild?.sort((a, b) => guildNames.indexOf(a.name) - guildNames.indexOf(b.name)), label: currentGuild[index].label };
    })
    const filtered = dataFormat.filter(x => x.data?.length > 0);
    /* some cases, don't use guild definition name from the database, use customized name defined in config.js */
    filtered.forEach((guildGroup, index) => {
      /* check if there is a custom label provided for the any guild def */
      guildGroup.data.forEach((singleGuild) => {
        const matched = currentGuild[index].list.find(definedGuild => definedGuild.name === singleGuild.name);
        if (matched != null) {
          singleGuild.label = matched.label;
        } else {
          singleGuild.label = singleGuild.name;
        }
      });
    });

    return filtered;
  } catch (error) {
    console.error(error);
  }
  return null;
}

/* get species table,

using post to allow the complicated input data format */

export async function getSppTable (year, data) {
  const apiFct = '/species/get-species-list';
  try {
    const response = await abmiAxios.post(apiFct, { data: data, year });
    const data2 = response.data;
    return data2;
  } catch (error) {
    console.error(error);
  }
  return null;
}

/* get habitat table */
export async function getHabitatTable () {
  const apiFct = '/habitat/get-all-habitat';
  try {
    const response = await abmiAxios.get(apiFct);
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

/* get autoComplete species table */
export async function autoCompleteSpeciesName (groupId, year, mask) {
  const apiFct = '/species/get-auto-compelete-species';
  const params = { year, groupId, mask }
  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

const abmiApi = {
  getGuilds,
  loadSpeciesInfo,
  getPreNextRecordInfo,
  getSppTable
};

export default abmiApi;
